import { render, staticRenderFns } from "./ServerPack.vue?vue&type=template&id=fe38aba8&scoped=true"
import script from "./ServerPack.vue?vue&type=script&lang=js"
export * from "./ServerPack.vue?vue&type=script&lang=js"
import style0 from "./ServerPack.vue?vue&type=style&index=0&id=fe38aba8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe38aba8",
  null
  
)

export default component.exports